import { jobColors } from "../../../../../ui/colors";

export const STATUS_STYLES: Record<string, { bg: string; color: string }> = {
  scheduled: { bg: jobColors.scheduled.bg, color: jobColors.scheduled.color },
  completed: { bg: jobColors.scheduled.bg, color: jobColors.completed.color },
  inprogress: { bg: jobColors.inProgress.bg, color: jobColors.inProgress.color },
  cancelled: { bg: jobColors.cancelled.bg, color: jobColors.cancelled.color },
};

export const DEFAULT_STATUS_STYLE = {
  bg: "transparent",
  color: "inherit",
};

export const getStatusColor = (status: string): { bg: string; color: string }  => {
  return STATUS_STYLES[status.toLowerCase()] ?? DEFAULT_STATUS_STYLE; 
};